export const FETCH_PROVISIONAL_OFFER_REQUEST = 'FETCH_PROVISIONAL_OFFER_REQUEST';
export const FETCH_PROVISIONAL_OFFER_SUCCESS = 'FETCH_PROVISIONAL_OFFER_SUCCESS';
export const FETCH_PROVISIONAL_OFFER_FAILURE = 'FETCH_PROVISIONAL_OFFER_FAILURE';
export const RESET_PROVISIONAL_OFFER_FAILURE = 'RESET_PROVISIONAL_OFFER_FAILURE';

export const fetchProvisionalOfferRequest = applicationId => ({
  type: FETCH_PROVISIONAL_OFFER_REQUEST,
  applicationId,
});

export const fetchProvisionalOfferSuccess = payload => ({
  type: FETCH_PROVISIONAL_OFFER_SUCCESS,
  payload,
});

export const fetchProvisionalOfferFailure = error => ({
  type: FETCH_PROVISIONAL_OFFER_FAILURE,
  payload: error,
});

export const resetProvisionalOfferFailure = () => ({ type: RESET_PROVISIONAL_OFFER_FAILURE });
